






















import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import DetailStore from '@/store/DetailStore';

@Component({
    components: {}
})
export default class ForceGraph2dBtn extends Vue {
    detailData = DetailStore.state;
    get loading() {
        return this.detailData.loading;
    }

    isBacked = false;

    isDown = false;
    slideX = '55px' as any;
    percentage = 5;
    timer = null;

    async back3d () {
        if (this.isBacked === false) {
            this.isBacked = true;
            this.$bus.$emit('action-script-stop');
            await this.$sleep(0);
            this.$bus.$emit('view-change', '2d', '3d');
            this.$bus.$emit('action-script-run');
        }
    }

    zoomIn() {
        this.$bus.$emit('force-zoom-in');
    }

    zoomOut() {
        this.$bus.$emit('force-zoom-out');
    }

    fullScreen() {
        this.$bus.$emit('force-RightLeft-out');
        DetailStore.changeLoading({
            type: 'leftRight',
            flag: !this.detailData.loading.leftRight
        });
    }

    resetForceGraph() {
        this.$bus.$emit('force-graph-reset');
    }
    mounted() {
        let key;
        document['onkeydown'] = (e) => {
            if ( e.key === 's' || e.key === 'd' || e.key === 'S' || e.key === 'D') {
                key = e.key;
            } else {
                key += e.key;
            }
            if (key === 'sk' || key === 'SK') {
                this.fullScreen();
            }
            if (key === 'dj' || key === 'DJ') {
                this.back3d();
            }
        }
    }
    beforeDestroy () {
        document.onkeydown = null;
    }
}
